// Generated by ts-to-zod
import { z } from 'zod';

export const configurationChangelogObjectTypeSchema = z.string();

export const configurationChangelogVersionEventSchema = z.union([
  z.literal('create'),
  z.literal('update'),
  z.literal('delete'),
]);

export const configurationChangelogEntrySchema = z.object({
  versionId: z.number(),
  tenant: z.string(),
  organizationId: z.number(),
  objectType: configurationChangelogObjectTypeSchema,
  objectId: z.number(),
  versionEvent: configurationChangelogVersionEventSchema,
  versionCreatedAt: z.string(),
  modifierId: z.number().nullable(),
  changedFields: z.array(z.string()),
  name: z.string().optional().nullable(),
  createdAt: z.string().optional().nullable(),
  modifiedAt: z.string().optional().nullable(),
  creatorId: z.number().optional().nullable(),
  description: z.string().optional().nullable(),
  snapshot: z.record(z.unknown()).optional(),
});
